import React, { FC, PropsWithChildren, ReactNode } from 'react';

import { useDropdown, useToggle } from '../../../../hooks';
import { cn, resultIf } from '../../../../utils';
import { AsLink, Button, ChevronIcon } from '../../../common';
import RotatedOpener from '../../../common/utils/RotatedOpener';
import Block from '../Block';

import './BlockDropdown.scoped.scss';

interface Props {
  header: ReactNode;
  showToggle?: boolean;
  headerClassname?: string;
}

const BlockDropdown: FC<PropsWithChildren<Props>> = ({
  header,
  showToggle = true,
  headerClassname,
  children,
}) => {
  const [active, toggle] = useToggle(true);
  const [contentElement, height] = useDropdown(active);

  const blockHeader = (): ReactNode => {
    return (
      <div className="block-dropdown__header">
        <div
          className={cn(
            'block-dropdown__heading',
            resultIf(!showToggle, 'block-dropdown__heading--only')
          )}
        >
          {header}
        </div>
        {showToggle && <RotatedOpener active={active} onClicked={toggle} />}
      </div>
    );
  };

  return (
    <div className={cn('block-dropdown', resultIf(active, 'active'))}>
      <Block>
        <Block.Content>
          <Block.Header withPadding className={cn(headerClassname)}>
            {blockHeader()}
          </Block.Header>
          <Block.Body className="block-dropdown__body" style={{ maxHeight: height }}>
            <div className="block-dropdown__content" ref={contentElement}>
              <div className="block-dropdown__content-inner">{children}</div>
            </div>
          </Block.Body>
          <Block.Footer>
            <div className="block-dropdown__footer">
              {!showToggle ? (
                <div className="block-dropdown__toggle">
                  <AsLink>
                    <Button onClick={toggle}>{active ? 'Скрыть' : 'Подробнее'}</Button>
                  </AsLink>
                </div>
              ) : (
                <div className="block-dropdown__toggle-arrow">
                  <div className="block-dropdown__footer-close" onClick={toggle}>
                    <ChevronIcon
                      direction="down"
                      color="var(--black-color)"
                      title="Свернуть блок"
                    />
                  </div>
                </div>
              )}
            </div>
          </Block.Footer>
        </Block.Content>
      </Block>
    </div>
  );
};

export default BlockDropdown;
